<rt-dropdown
  [hasNoBorderRadius]="hasStickyFooter"
  [style.width.px]="width"
  [style.min-width.px]="minWidth"
  [style.max-width.px]="maxWidth"
  [style.max-height]="noMaxHeight ? 'none' : null"
  [class.light]="light"
  [class.has-divider]="hasDivider"
  [class.dark]="dark"
  [class.radius-default]="radiusDefault"
  #rtDropdown
>
  <ng-template [ngTemplateOutlet]="template"> </ng-template>
</rt-dropdown>
<div *ngIf="hasStickyFooter" class="sticky-footer">
  <ng-template
    [ngTemplateOutlet]="footerTemplate"
    [ngTemplateOutletContext]="footerTemplateContext"
  >
  </ng-template>
</div>
